import { defineMessages } from "react-intl";

const RECOVERY_CONTROLS = "recovery-controls";

const recoveryControlsMessages = defineMessages({
  contactCustomerHelp: {
    id: `${RECOVERY_CONTROLS}.contact-customer-help`,
    defaultMessage: "Still need help? <a>Contact customer help</a>"
  },
  tryAgain: {
    id: `${RECOVERY_CONTROLS}.try-again`,
    defaultMessage: "Having trouble? <button>Go back and try again</button>",
    description:
      "Guidance and button to help user if they become stuck in the process at entering the verification code."
  }
});

export default recoveryControlsMessages;
